import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-component',
  templateUrl: './component.component.html',
  styleUrls: ['./component.component.css']
})
export class WarehouseComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
